(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-hp-product-card-assets"] && !Shopify.designMode) return;
  try {
    if (!window.__quickAddModalBound) {
    window.__quickAddModalBound = true;

    var quickAddInflight = {};
    var reopenCartAfterQuickAdd = false;
    var activePlusLoader = null;
    var plusLoaderShownAt = 0;
    var PLUS_LOADER_MIN_MS = 280;

    function getQuickAddHost() {
      return document.querySelector('[data-quick-add-host]') || document.body;
    }

    var OPEN_LOADER_SELECTOR =
      '.product-card__quick-add.is-loading, .fresh-cart-drawer__upsell-add.is-loading, .product-pdp__addon-quick-buy.is-loading';

    function clearPlusLoader(immediate) {
      function wipe() {
        if (activePlusLoader) {
          activePlusLoader.classList.remove('is-loading');
          activePlusLoader.removeAttribute('aria-busy');
          activePlusLoader = null;
        }
        document.querySelectorAll(OPEN_LOADER_SELECTOR).forEach(function (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
        plusLoaderShownAt = 0;
      }

      if (immediate || !plusLoaderShownAt) {
        wipe();
        return;
      }

      var elapsed = Date.now() - plusLoaderShownAt;
      var delay = Math.max(0, PLUS_LOADER_MIN_MS - elapsed);
      window.setTimeout(wipe, delay);
    }

    function setPlusLoader(trigger) {
      clearPlusLoader(true);
      if (!trigger) return null;

      var loaderBtn = null;

      if (
        trigger.classList.contains('product-card__quick-add') ||
        trigger.classList.contains('fresh-cart-drawer__upsell-add') ||
        trigger.classList.contains('product-pdp__addon-quick-buy')
      ) {
        loaderBtn = trigger;
      } else if (trigger.closest('[data-fresh-upsell]')) {
        var upsell = trigger.closest('[data-fresh-upsell]');
        loaderBtn = upsell.querySelector('.fresh-cart-drawer__upsell-add') || trigger;
      } else {
        var card = trigger.closest('[data-product-card]');
        if (card) loaderBtn = card.querySelector('.product-card__quick-add');
      }

      if (!loaderBtn) return null;

      loaderBtn.classList.add('is-loading');
      loaderBtn.setAttribute('aria-busy', 'true');
      activePlusLoader = loaderBtn;
      plusLoaderShownAt = Date.now();
      return loaderBtn;
    }

    function closeQuickAddModal(modal, onDone) {
      if (!modal) {
        if (typeof onDone === 'function') onDone();
        return;
      }
      if (!modal.classList.contains('is-open')) {
        if (typeof onDone === 'function') onDone();
        return;
      }

      clearPlusLoader();
      // Instant close — no fade-out.
      modal.classList.remove('is-open', 'is-closing');
      modal.setAttribute('aria-hidden', 'true');
      modal.removeAttribute('data-reopen-cart');

      if (window.ThemeOverlay) {
        window.ThemeOverlay.hide('quick-add');
      } else if (window.history && window.history.replaceState && window.location.hash) {
        var hash = window.location.hash;
        if (!hash || hash === '#' || hash.indexOf('#quick-add-') === 0) {
          window.history.replaceState(
            null,
            document.title,
            window.location.pathname + window.location.search
          );
        }
      }

      if (typeof onDone === 'function') {
        onDone();
      }

      if (reopenCartAfterQuickAdd) {
        reopenCartAfterQuickAdd = false;
        window.setTimeout(function () {
          if (window.FreshCartDrawer && typeof window.FreshCartDrawer.open === 'function') {
            window.FreshCartDrawer.open();
          }
        }, 120);
      }
    }

    window.closeQuickAddModal = closeQuickAddModal;
    window.__setQuickAddReopenCart = function (value) {
      reopenCartAfterQuickAdd = !!value;
    };

    function mountQuickAddHtml(html, modalId) {
      var host = getQuickAddHost();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var modal = doc.querySelector('.quick-add-modal');

      if (!modal) return null;

      // Category rows can pre-render the same product modal multiple times
      // (duplicate ids). Remove every stale copy so getElementById / open
      // never resolve to a modal trapped under [hidden].
      if (modalId) {
        document.querySelectorAll('[id="' + modalId.replace(/"/g, '\\"') + '"]').forEach(function (stale) {
          stale.remove();
        });
      } else {
        var parsedId = modal.getAttribute('id');
        if (parsedId) {
          document.querySelectorAll('[id="' + parsedId.replace(/"/g, '\\"') + '"]').forEach(function (stale) {
            stale.remove();
          });
        }
      }

      Array.prototype.forEach.call(doc.querySelectorAll('style'), function (styleEl) {
        host.appendChild(document.importNode(styleEl, true));
      });

      var imported = document.importNode(modal, true);
      host.appendChild(imported);

      if (typeof window.initQuickAddModals === 'function') {
        window.initQuickAddModals(imported);
      }

      return imported;
    }

    function showQuickAddModal(modal) {
      if (!modal) {
        clearPlusLoader();
        return;
      }

      var host = getQuickAddHost();
      // Never open a modal that is still parked inside a [hidden] section wrapper.
      if (host && (modal.parentElement !== host || modal.closest('[hidden]'))) {
        host.appendChild(modal);
      }

      if (window.history && window.history.replaceState && window.location.hash) {
        var hash = window.location.hash;
        if (!hash || hash === '#' || hash.indexOf('#quick-add-') === 0) {
          window.history.replaceState(
            null,
            document.title,
            window.location.pathname + window.location.search
          );
        }
      }

      function reveal() {
        // Only one quick-add dialog should be open at a time.
        document.querySelectorAll('.quick-add-modal.is-open').forEach(function (el) {
          if (el === modal) return;
          el.classList.remove('is-open', 'is-closing');
          el.setAttribute('aria-hidden', 'true');
        });

        modal.classList.remove('is-closing');
        // Force closed styles before opening so the fade-up always plays.
        void modal.offsetWidth;
        // Clear a leftover ATC spinner if this modal was reused after add-to-cart.
        var stuckSubmit = modal.querySelector('[data-qa-submit].is-loading');
        if (stuckSubmit) {
          var label = stuckSubmit.getAttribute('data-qa-label') || stuckSubmit.textContent || 'Add To Cart';
          stuckSubmit.classList.remove('is-loading');
          stuckSubmit.removeAttribute('aria-busy');
          stuckSubmit.removeAttribute('data-qa-label');
          stuckSubmit.disabled = false;
          stuckSubmit.textContent = label;
        }
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        if (window.ThemeOverlay) {
          window.ThemeOverlay.show('quick-add', function () {
            closeQuickAddModal(modal);
          });
        }

        clearPlusLoader();
      }

      // Double rAF so freshly mounted HTML paints closed, then animates open.
      requestAnimationFrame(function () {
        requestAnimationFrame(reveal);
      });
    }

    function openQuickAddModal(modalId, src, trigger) {
      var plus = setPlusLoader(trigger);
      var host = getQuickAddHost();
      var modal = modalId ? document.getElementById(modalId) : null;

      // Pre-rendered modals in [hidden] wrappers blink if opened in place — always
      // lift them to the host (or fetch) instead of opening under [hidden].
      if (modal && modal.closest('[hidden]')) {
        if (host) {
          // Drop sibling duplicates with the same id before moving.
          document.querySelectorAll('[id="' + modalId.replace(/"/g, '\\"') + '"]').forEach(function (el) {
            if (el !== modal) el.remove();
          });
          host.appendChild(modal);
        } else {
          modal = null;
        }
      }

      if (modal) {
        if (host && modal.parentElement !== host) {
          host.appendChild(modal);
        }
        if (typeof window.initQuickAddModals === 'function') {
          window.initQuickAddModals(modal);
        }
        showQuickAddModal(modal);
        return;
      }

      if (!src) {
        clearPlusLoader();
        return;
      }

      if (quickAddInflight[src]) return;

      quickAddInflight[src] = fetch(src, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Quick add failed');
          return response.text();
        })
        .then(function (html) {
          var mounted = mountQuickAddHtml(html, modalId);
          showQuickAddModal(mounted);
        })
        .catch(function () {
          clearPlusLoader();
          if (window.ThemeOverlay) window.ThemeOverlay.hide('quick-add');
        })
        .finally(function () {
          delete quickAddInflight[src];
        });
    }

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-quick-add-open]');
      if (openTrigger) {
        // Image / title links should navigate to the PDP unless the card
        // explicitly opts into whole-card Quick View (BYOB).
        var isProductNavLink =
          openTrigger.classList.contains('product-card__image-link') ||
          openTrigger.classList.contains('product-card__title');
        var forceCardQuickAdd = !!openTrigger.closest('[data-open-quick-add-on-click]');
        if (isProductNavLink && !forceCardQuickAdd) {
          return;
        }

        event.preventDefault();
        // Cart / search drawers sit above the overlay — close them before quick view.
        var fromCart = !!openTrigger.closest('[data-fresh-cart-drawer]');
        reopenCartAfterQuickAdd = fromCart;
        if (
          fromCart &&
          window.FreshCartDrawer &&
          typeof window.FreshCartDrawer.close === 'function'
        ) {
          window.FreshCartDrawer.close();
        }
        if (
          openTrigger.closest('[data-fresh-search-drawer]') &&
          window.FreshSearchDrawer &&
          typeof window.FreshSearchDrawer.close === 'function'
        ) {
          window.FreshSearchDrawer.close();
        }
        var modalId = openTrigger.getAttribute('data-quick-add-open');
        var src = openTrigger.getAttribute('data-quick-add-src') || '';
        // Guard against predictive-search URLs that already contain ?… then get ?view= appended.
        if (src) {
          try {
            var u = new URL(src, window.location.origin);
            var path = u.pathname;
            src = path + '?view=quick-add';
          } catch (e) {
            var q = src.indexOf('?');
            src = (q >= 0 ? src.slice(0, q) : src) + '?view=quick-add';
          }
        }
        openQuickAddModal(modalId, src, openTrigger);
        return;
      }

      var closeTrigger = event.target.closest('[data-quick-add-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeQuickAddModal(closeTrigger.closest('.quick-add-modal'));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-collection-filters"] && !Shopify.designMode) return;
  try {
    class CCollectionFiltersComponent extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('[data-filters-form]');
      this.closeButton = this.querySelector('[data-close-filters]');
      this.filterGroups = this.querySelectorAll('.c-filter-group');
      this.priceFilter = this.querySelector('[data-price-filter]');
      this.bindEvents();
      this.initPriceSlider();
      this.initToggleIcons();
    }

    bindEvents() {
      // Close button
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.dispatchEvent(new CustomEvent('filters:close', { bubbles: true }));
        });
      }

      // Form submission
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.applyFilters();
        });

        // Auto-submit on checkbox change (except collection filters)
        this.form.querySelectorAll('input[type="checkbox"]:not([name="collection_filter"])').forEach((input) => {
          input.addEventListener('change', () => {
            this.applyFilters();
          });
        });

        // Collection filter checkbox handling - navigate to filter URL
        this.form.querySelectorAll('input[name="collection_filter"]').forEach((input) => {
          input.addEventListener('change', (e) => {
            const checkbox = e.target;
            const filterUrl = checkbox.dataset.filterUrl;

            if (checkbox.checked && filterUrl) {
              // Navigate to the filter URL via AJAX
              document.dispatchEvent(
                new CustomEvent('filters:apply', {
                  bubbles: true,
                  detail: { url: filterUrl },
                })
              );
            } else {
              // If unchecked, clear the collection filter
              const baseUrl = window.location.pathname;
              const params = new URLSearchParams(window.location.search);
              params.delete('collection_filter');
              const newUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

              document.dispatchEvent(
                new CustomEvent('filters:apply', {
                  bubbles: true,
                  detail: { url: newUrl },
                })
              );
            }

            // Uncheck other collection filter checkboxes (single select behavior)
            if (checkbox.checked) {
              this.form.querySelectorAll('input[name="collection_filter"]').forEach((other) => {
                if (other !== checkbox) {
                  other.checked = false;
                }
              });
            }
          });
        });
      }

      // Toggle icons on details open/close
      this.filterGroups.forEach((group) => {
        group.addEventListener('toggle', () => {
          const toggle = group.querySelector('.c-filter-group__toggle');
          if (toggle) {
            toggle.textContent = group.open ? '-' : '+';
          }
        });
      });
    }

    initToggleIcons() {
      // Set initial toggle icons
      this.filterGroups.forEach((group) => {
        const toggle = group.querySelector('.c-filter-group__toggle');
        if (toggle) {
          toggle.textContent = group.open ? '-' : '+';
        }
      });
    }

    initPriceSlider() {
      if (!this.priceFilter) return;

      const minInput = this.priceFilter.querySelector('[data-price-min]');
      const maxInput = this.priceFilter.querySelector('[data-price-max]');
      const rangeEl = this.priceFilter.querySelector('[data-price-range]');
      const minDisplay = this.priceFilter.querySelector('[data-price-min-display]');
      const maxDisplay = this.priceFilter.querySelector('[data-price-max-display]');

      if (!minInput || !maxInput || !rangeEl) return;

      const updateSlider = () => {
        const min = parseFloat(minInput.min);
        const max = parseFloat(minInput.max);
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);

        // Calculate percentages
        const minPercent = ((minVal - min) / (max - min)) * 100;
        const maxPercent = ((maxVal - min) / (max - min)) * 100;

        // Update range bar position
        rangeEl.style.left = minPercent + '%';
        rangeEl.style.width = maxPercent - minPercent + '%';

        // Update display values (dollars)
        if (minDisplay) {
          minDisplay.textContent = '$' + Math.round(minVal);
        }
        if (maxDisplay) {
          maxDisplay.textContent = '$' + Math.round(maxVal);
        }
      };

      // Initial update
      updateSlider();

      // Debounce function for filter application
      let debounceTimer;
      const debounceApply = () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          this.applyFilters();
        }, 800);
      };

      // Min slider events
      minInput.addEventListener('input', () => {
        let minVal = parseFloat(minInput.value);
        let maxVal = parseFloat(maxInput.value);

        // Prevent min from exceeding max
        if (minVal >= maxVal) {
          minInput.value = maxVal - 1;
        }

        updateSlider();
      });

      minInput.addEventListener('change', debounceApply);

      // Max slider events
      maxInput.addEventListener('input', () => {
        let minVal = parseFloat(minInput.value);
        let maxVal = parseFloat(maxInput.value);

        // Prevent max from going below min
        if (maxVal <= minVal) {
          maxInput.value = minVal + 1;
        }

        updateSlider();
      });

      maxInput.addEventListener('change', debounceApply);
    }

    applyFilters() {
      const formData = new FormData(this.form);
      const params = new URLSearchParams();

      // Preserve collection_filter from URL if it exists
      const currentParams = new URLSearchParams(window.location.search);
      const collectionFilter = currentParams.get('collection_filter');
      if (collectionFilter) {
        params.set('collection_filter', collectionFilter);
      }

      for (const [key, value] of formData.entries()) {
        // Skip collection_filter as it's handled separately via checkbox click
        if (key === 'collection_filter') continue;
        if (value) {
          params.append(key, value);
        }
      }

      const url = `${window.location.pathname}?${params.toString()}`;

      // Dispatch custom event for AJAX filtering instead of full page reload
      document.dispatchEvent(
        new CustomEvent('filters:apply', {
          bubbles: true,
          detail: { url },
        })
      );
    }

    reinitialize() {
      // Rebind events after AJAX content update
      this.form = this.querySelector('[data-filters-form]');
      this.closeButton = this.querySelector('[data-close-filters]');
      this.filterGroups = this.querySelectorAll('.c-filter-group');
      this.priceFilter = this.querySelector('[data-price-filter]');
      this.bindEvents();
      this.initPriceSlider();
      this.initToggleIcons();
    }
  }

  if (!customElements.get('c-collection-filters-component')) {
    customElements.define('c-collection-filters-component', CCollectionFiltersComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crawl-budget-optimization"] && !Shopify.designMode) return;
  try {
    // Preconnect to search engines para mejorar crawl speed
  if (document.head) {
    const preconnects = [
      'https://www.google.com',
      'https://www.googlebot.com',
      'https://search.google.com'
    ];
    
    preconnects.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  // Lazy load non-critical content para mejorar performance
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // JSON-LD optimization para mejor crawling
  function addStructuredData() {
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (!existingScript && window.meta && window.meta.page) {
      const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": window.location.href,
        "name": document.title,
        "publisher": {
          "@type": "Organization",
          "name": "{{ shop.name }}",
          "url": "{{ shop.url }}"
        }
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStructuredData);
  } else {
    addStructuredData();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-assets-ava-redesign"] && !Shopify.designMode) return;
  try {
    if (!window.__quickAddModalBound) {
    window.__quickAddModalBound = true;

    var quickAddInflight = {};

    function getQuickAddHost() {
      return document.querySelector('[data-quick-add-host]') || document.body;
    }

    function closeQuickAddModal(modal) {
      if (!modal || !modal.classList.contains('is-open')) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('hidden', '');

      if (window.ThemeOverlay) {
        window.ThemeOverlay.hide('quick-add');
      } else if (window.history && window.history.replaceState && window.location.hash) {
        var hash = window.location.hash;
        if (!hash || hash === '#' || hash.indexOf('#quick-add-') === 0) {
          window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
        }
      }
    }

    window.closeQuickAddModal = closeQuickAddModal;

    function showQuickAddModal(modal) {
      if (!modal) return;

      if (window.history && window.history.replaceState && window.location.hash) {
        var hash = window.location.hash;
        if (!hash || hash === '#' || hash.indexOf('#quick-add-') === 0) {
          window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
        }
      }

      modal.classList.add('is-open');
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');

      if (window.ThemeOverlay) {
        window.ThemeOverlay.show('quick-add', function () {
          closeQuickAddModal(document.querySelector('.quick-add-modal.is-open'));
        });
      }

      if (window.ThemeLoader) {
        window.ThemeLoader.hide();
      }
    }

    function mountQuickAddHtml(html, modalId) {
      var host = getQuickAddHost();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var modal = doc.getElementById(modalId);

      if (!modal) {
        modal = doc.querySelector('.quick-add-modal');
      }

      if (!modal) return null;

      Array.prototype.forEach.call(doc.querySelectorAll('style'), function (styleEl) {
        host.appendChild(document.importNode(styleEl, true));
      });

      host.appendChild(document.importNode(modal, true));
      var mounted =
        document.getElementById(modalId) || host.querySelector('.quick-add-modal:last-of-type');

      if (mounted && typeof window.initQuickAddModals === 'function') {
        window.initQuickAddModals(mounted.parentNode || document);
      }

      return mounted;
    }

    function openQuickAddModal(modalId, src) {
      var modal = modalId ? document.getElementById(modalId) : null;
      if (modal) {
        showQuickAddModal(modal);
        return;
      }

      if (!src) {
        if (window.ThemeLoader) window.ThemeLoader.hide();
        return;
      }

      if (quickAddInflight[src]) return;

      quickAddInflight[src] = fetch(src, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Quick add failed');
          return response.text();
        })
        .then(function (html) {
          var mounted = mountQuickAddHtml(html, modalId);
          showQuickAddModal(mounted);
        })
        .catch(function () {
          if (window.ThemeLoader) window.ThemeLoader.hide();
        })
        .finally(function () {
          delete quickAddInflight[src];
        });
    }

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-quick-add-open]');
      if (openTrigger) {
        event.preventDefault();
        openQuickAddModal(
          openTrigger.getAttribute('data-quick-add-open'),
          openTrigger.getAttribute('data-quick-add-src')
        );
        return;
      }

      var closeTrigger = event.target.closest('[data-quick-add-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeQuickAddModal(closeTrigger.closest('.quick-add-modal'));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-overlay"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.ThemeOverlay) return;

    var overlayEl = document.querySelector('[data-theme-overlay]');
    var layers = [];
    var scrollY = 0;

    function lockScroll() {
      if (document.body.classList.contains('theme-scroll-lock')) return;

      scrollY = window.pageYOffset != null ? window.pageYOffset : window.scrollY;
      document.body.classList.add('theme-scroll-lock');
      document.body.style.top = '-' + scrollY + 'px';
    }

    function cleanUrlHash() {
      if (!window.history || !window.history.replaceState) return;

      var hash = window.location.hash;
      if (!hash || hash === '#' || hash.indexOf('#quick-add-') === 0) {
        window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
      }
    }

    function scrollToYInstant(y) {
      var root = document.documentElement;
      var prevRoot = root.style.scrollBehavior;
      var prevBody = document.body.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
      root.classList.add('overlay-scroll-restoring');

      var apply = window.__overlayScrollLockOrigScrollTo || window.scrollTo.bind(window);
      try {
        apply({ top: y, left: 0, behavior: 'instant' });
      } catch (e) {
        apply(0, y);
      }

      root.style.scrollBehavior = prevRoot;
      document.body.style.scrollBehavior = prevBody;
      window.setTimeout(function () {
        root.classList.remove('overlay-scroll-restoring');
      }, 0);
    }

    function unlockScroll() {
      if (!document.body.classList.contains('theme-scroll-lock')) return;

      var y = scrollY;
      document.body.classList.remove('theme-scroll-lock');
      document.body.style.top = '';
      // Instant restore — html { scroll-behavior: smooth } would otherwise
      // animate from top back to the saved position after unlock.
      scrollToYInstant(y);
    }

    function syncOverlay() {
      var isOpen = layers.length > 0;

      if (overlayEl) {
        overlayEl.classList.toggle('is-visible', isOpen);
        overlayEl.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }

      if (isOpen) {
        lockScroll();
      } else {
        unlockScroll();
        cleanUrlHash();
      }
    }

    function closeTop() {
      var top = layers[layers.length - 1];
      if (!top) return;

      if (typeof top.onClose === 'function') {
        top.onClose();
      } else {
        window.ThemeOverlay.hide(top.id);
      }
    }

    if (overlayEl) {
      overlayEl.addEventListener('click', closeTop);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && layers.length) {
        closeTop();
      }
    });

    window.ThemeOverlay = {
      show: function (id, onClose) {
        if (!id) return;

        layers = layers.filter(function (layer) {
          return layer.id !== id;
        });

        layers.push({ id: id, onClose: onClose });
        syncOverlay();
      },

      hide: function (id) {
        if (!id) return;

        layers = layers.filter(function (layer) {
          return layer.id !== id;
        });

        syncOverlay();
      },

      closeTop: closeTop,

      isOpen: function (id) {
        return layers.some(function (layer) {
          return layer.id === id;
        });
      }
    };
  })();

  (function () {
    if (window.ThemeLoader) return;

    var minVisibleMs = 180;
    var shownAt = 0;
    var hideTimer = null;
    var root = document.querySelector('[data-theme-loader-root]');

    function setAria(isVisible) {
      if (!root) return;
      root.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    function hideAfterDelay() {
      var elapsed = Date.now() - shownAt;
      var delay = Math.max(0, minVisibleMs - elapsed);

      if (hideTimer) clearTimeout(hideTimer);

      hideTimer = setTimeout(function () {
        document.body.classList.remove('theme-loader-active');
        setAria(false);
        hideTimer = null;
      }, delay);
    }

    window.ThemeLoader = {
      show: function () {
        if (hideTimer) {
          clearTimeout(hideTimer);
          hideTimer = null;
        }

        shownAt = Date.now();
        document.body.classList.add('theme-loader-active');
        setAria(true);
      },

      hide: hideAfterDelay
    };

    function resolveLoaderTarget(trigger) {
      var modalId = trigger.getAttribute('data-quick-add-open');
      if (modalId) return modalId;

      var targetSelector = trigger.getAttribute('data-theme-loader-target');
      if (targetSelector) {
        return targetSelector.charAt(0) === '#' ? targetSelector.slice(1) : targetSelector;
      }

      return null;
    }

    function targetIsReady(modalId) {
      if (!modalId) return false;
      var modal = document.getElementById(modalId);
      return Boolean(modal && modal.classList.contains('is-open'));
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-theme-loader]');
      if (!trigger) return;

      var targetId = resolveLoaderTarget(trigger);
      window.ThemeLoader.show();

      if (!targetId) return;

      var attempts = 0;

      // Allow ~3s for lazy-fetched quick-add HTML; opener also calls hide().
      function waitForOpen() {
        attempts += 1;

        if (targetIsReady(targetId) || attempts > 180) {
          window.ThemeLoader.hide();
          return;
        }

        requestAnimationFrame(waitForOpen);
      }

      requestAnimationFrame(waitForOpen);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
